import React from 'react'

export const UserCounter = () => {
  return (
    <div className="relative text-center">
      <img
        className="top-1/2 -translate-y-1/2 left-8 absolute"
        src="/quiz/icons/user1.svg"
        alt="vector"
      />
      <p className="text-[64px] font-bold tracking-[-1px] leading-[72px]"> 2M+</p>
      <p className="mt-2 mx-auto font-medium max-w-[200px] text-[#101A36B2]">
        users already cleaned their phones with <br />
        <strong className="font-semibold text-white">Clean Master</strong>
      </p>
      <img
        className="top-1/2 -translate-y-1/2 right-8 absolute scale-x-[-1]"
        src="/quiz/icons/user1.svg"
        alt="vector"
      />
    </div>
  )
}
